const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Yash Sharma</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Internal Operations Head, UPES-CSI</li>
    <li>
        Pre Final year student at University of Petroleum and Energy Studies (UPES), pursuing Bachelors of Technology in Computer Science and Engineering with specialization in Cybersecurity and Digital Forensics.
    </li>
    <li>
        Cybersecurity intern at Uttarakhand Police (Special Task Force) 2025
    </li>
    <li>
        NCC Cadet 2021-2023
    </li>
    <li>
        Completed ATC camp 2022
    </li>
</ul>
</div>
</div>
</>
}

export default data;
